import { css } from '@emotion/core';
import { variables as vars, media, rgba } from '@domain-group/fe-brary';
var colour = vars.colour,
  font = vars.font,
  global = vars.global;
export var popup = /*#__PURE__*/css("display:inline-block;position:absolute;border:1px solid ", colour.neutral100, ";pointer-events:auto;background-color:", colour.white, ";box-shadow:0 1px 8px 0 ", rgba(colour.black, 0.15), ";z-index:", Number(global.layerFloating) + 1, ";min-width:320px;min-height:140px;width:320px;top:45px;left:-195px;", media('>=tablet'), "{left:-85px;}&::after,&::before{bottom:100%;left:80%;", media('>=tablet'), "{left:50%;}border:solid transparent;content:' ';height:0;width:0;position:absolute;pointer-events:none;border-color:", rgba(colour.white, 0), ";}&::before{border-bottom-color:", colour.neutral200, ";border-width:10px;margin-left:-10px;top:-21px;}&::after{border-bottom-color:", colour.white, ";border-width:10px;margin-left:-10px;}");
export var title = /*#__PURE__*/css("margin-top:15px;color:", colour.allhomesNavy600, ";font-family:", font.headingFontFamily, ";font-size:", font.h4FontSize, ";font-weight:600;line-height:1.33;");
export var message = /*#__PURE__*/css("margin-top:2px;color:", colour.allhomesNavy600, ";font-family:", font.bodyFontFamily, ";font-size:", font.smallFontSize, ";line-height:1.43;");
export var closeButton = /*#__PURE__*/css("position:absolute;top:8px;right:8px;background:none;border:0;color:", colour.neutral700, ";cursor:pointer;");
export var buttonGroup = {
  name: "1hw29i9",
  styles: "margin-top:12px;"
};
export var button = {
  name: "10b7hc7",
  styles: "min-height:unset;min-width:100px;padding:5px 10px;"
};
export var content = {
  name: "vw2287",
  styles: "display:flex;align-items:center;flex-direction:row;padding:0 15px;"
};
export var contentMiddle = {
  name: "1wmte3b",
  styles: "margin:0 15px;"
};